import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-scissors-icon',
  templateUrl: './general-scissors.component.html'
})
export class GeneralScissorsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
